import React, { useEffect, useState } from "react";
import api from "../../../api";
import Banner from "./include/Banner";

const API_URL = `${process.env.REACT_APP_API_URL}/api/research/journal`;

const ResearchMedicalJourney = () => {
  const [journalData, setJournalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Fetch API data
  useEffect(() => {
    const fetchJournalData = async () => {
      try {
        const response = await api.get(API_URL);
        setJournalData(response.data.journal.content);
      } catch (err) {
        console.error("Error fetching Journal data:", err);
        setError("Failed to load Medical Journal data.");
      } finally {
        setLoading(false);
      }
    };
    fetchJournalData();
  }, []);

  if (loading) {
    return <div className="container mt-5 text-center">Loading Journal details...</div>;
  }

  if (error || !journalData) {
    return (
      <div className="container mt-5 text-center text-danger">
        {error || "Medical Journal data not available."}
      </div>
    );
  }

  const { images, heading, content, button_url, button_text } = journalData;

  return (
    <>
      {/* Dynamic Banner */}
      <Banner bannerImages={images} heading={heading} />

      <section className="research_medical_journey_section">
        <div className="container ">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="res-content " >   <div className="sec-title text-center"><h2> {heading}</h2></div>
              
             <p style={{ textAlign: "justify"}}>{content}</p>


                {button_url && (
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    <a
                      href={button_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    
                    >
                      <button className="medical-click">{button_text}</button>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchMedicalJourney;
